import { api } from './api'

function assertSuccess(body: { success?: boolean; message?: string; data?: unknown }) {
  if (!body?.success) {
    throw new Error(body?.message || 'Request failed')
  }
  return body.data
}

export type VisibilityStatus = 'active_now' | 'scheduled' | 'expired' | 'disabled'

export type HomepageSectionAdminRow = {
  id: number
  storeId: number
  title: string | null
  subtitle: string | null
  sectionType: string
  sourceType: string
  categoryId: number | null
  isSystemGenerated: boolean
  systemKey: string | null
  sortOrder: number
  isActive: boolean
  startDate: string | null
  endDate: string | null
  visibilityStatus: VisibilityStatus
  manualProductIds?: number[]
  createdAt: string
  updatedAt: string
}

export async function listStoreHomepageSections(
  storeId: number | string,
): Promise<{ items: HomepageSectionAdminRow[] }> {
  const { data } = await api.get(`/admin/stores/${encodeURIComponent(String(storeId))}/homepage-sections`)
  return assertSuccess(data) as { items: HomepageSectionAdminRow[] }
}
